<template>
  <div class="vmp-order-rank" v-if="showRankList">
    <div class="vmp-order-rank-wap__title">
      <div class="line"></div>
      <div class="text">购买排行榜</div>
      <div class="line"></div>
    </div>
    <div class="vmp-order-rank-wap__bottom">
      <div class="vmp-order-rank-wap__header">
        <div class="rank">排名</div>
        <div class="user">用户</div>
        <div class="amount">金额</div>
      </div>
      <div class="order-rank-item" v-for="(shop, idx) in rankList" :key="shop?.shop_code">
        <div class="rank">
          <img class="order-rank-img" :src="require(`./img/rank-${idx}.png`)" alt="" />
        </div>
        <div class="nickname">{{ shop.shopNameStr }}</div>
        <div class="total">¥{{ shop.totalAmountStr }}</div>
      </div>
    </div>
  </div>
</template>
<script>
  import shopOrderRankMixin from '@/app-shared/mixins/shopOrderRankMixin';

  export default {
    name: 'VmpOrderBank',
    mixins: [shopOrderRankMixin],
    methods: {
      adaptStyle() {
        this.$nextTick(() => {
          let dom = document.querySelector('.vmp-notice-column');
          let orderRankDom = document.querySelector('.vmp-order-rank');
          // 公告 && 排行榜并存
          if (orderRankDom) {
            if (dom && dom.style.display !== 'none') {
              orderRankDom.style.top = '56px';
            } else {
              orderRankDom.style.top = '16px';
            }
          }
        });
      }
    }
  };
</script>
<style lang="less" scoped>
  .vmp-order-rank {
    position: absolute;
    z-index: 12;
    font-size: 16px;
    background-color: rgba(0, 0, 0, 0.4);
    -webkit-border-radius: 8px;
    border-radius: 8px;
    //width: 236px;
    //height: 182px;
    //padding-top: 16px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    left: 16px;
    padding-bottom: 6px;
    .vmp-order-rank-wap__title {
      line-height: 34px;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      //margin-bottom: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      font-size: 16px;
      //height: 40px;
      .line {
        width: 10px;
        height: 1px;
        background-color: rgba(255, 255, 255, 0.85);
      }
      .text {
        //width: 100px;
        margin: 0 4px;
        font-size: 14px;
      }
    }
    .vmp-order-rank-wap__bottom {
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.15), rgba(0, 0, 0, 0));
      //padding-right: 12px;
      //padding-left: 12px;
      //width: 236px;
      //height: 142px;
      box-sizing: border-box;
    }
    .vmp-order-rank-wap__header {
      display: flex;
      align-items: center;
      color: rgba(255, 255, 255, 0.75);
      //gap: 12px;
      padding-top: 4px;
      font-size: 12px;
      padding-left: 12px;
      padding-right: 12px;
      margin-bottom: 6px;
      .rank {
        line-height: 22px;
        width: 30px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .user {
        width: 84px;
        margin-left: 4px;
      }
      .amount {
        max-width: 100px;
        margin-left: 12px;
      }
    }
    .order-rank-item {
      height: 24px;
      line-height: 24px;
      display: flex;
      color: #fff;
      font-size: 12px;
      align-items: center;
      //background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.35));
      //gap: 12px;
      //margin-left: -12px;
      //margin-right: -12px;
      padding: 0 12px;
      font-weight: 400;
      .rank {
        line-height: 24px;
        width: 30px;
        height: 22px;
        //text-align: center;
        display: flex;
        justify-content: center;
        item-align: center;
        .order-rank-img {
          height: 20px;
          width: 20px;
        }
      }

      .nickname {
        width: 84px; // 最多展示6个汉字
        word-break: break-word;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        margin-left: 4px;
      }

      .total {
        max-width: 100px;
        word-break: break-word;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        margin-left: 12px;
      }

      .rank,
      .nickname,
      .total {
        line-height: 22px;
      }
    }

    .order-rank-item + .order-rank-item {
      margin-top: 4px;
    }
  }
</style>
